import React from 'react';
import { Template } from './types';

interface TemplatesDisplayProps {
  templates: Template[];
  onOpenTemplateModal: (template?: Template) => void; // Optional template for editing
  onApplyTemplate: (templateId: number) => void; // Placeholder for apply logic
}

const TemplatesDisplay: React.FC<TemplatesDisplayProps> = ({ 
  templates, 
  onOpenTemplateModal,
  onApplyTemplate
}) => {
  return (
    <div className="bg-white rounded-lg shadow">
      <div className="px-6 py-4 border-b">
        <h2 className="text-lg font-medium text-[#344854]">Schedule Templates</h2>
      </div>
      
      <div className="p-6">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
          {templates.map(template => (
            <div 
              key={template.id} 
              className="border border-gray-200 rounded-lg p-4 hover:border-[#3A5E63] hover:shadow-sm transition-all cursor-pointer"
              onClick={() => onOpenTemplateModal(template)} // Pass template for editing
            >
              <h3 className="font-medium text-[#344854]">{template.name}</h3>
              <p className="text-sm text-gray-500 mt-1">{template.description}</p>
              <div className="flex justify-between items-center mt-4">
                <button
                  className="text-sm text-[#3A5E63] hover:text-[#2a4548]"
                  onClick={(e) => {
                    e.stopPropagation(); // Prevent opening modal when clicking apply
                    onApplyTemplate(template.id);
                  }}
                >
                  Apply
                </button>
                
                <div className="text-sm text-gray-400">
                  {/* Indicator for template, like number of events */}
                  ⭐
                </div>
              </div>
            </div>
          ))}
          
          {/* Add New Template Card */}
          <div 
            className="border border-dashed border-gray-300 rounded-lg p-4 flex flex-col items-center justify-center text-center hover:border-[#3A5E63] hover:shadow-sm transition-all cursor-pointer h-full"
            onClick={() => onOpenTemplateModal()} // Call without template to create new
          >
            <div className="w-10 h-10 rounded-full bg-gray-100 flex items-center justify-center text-[#3A5E63] mb-2">
              +
            </div>
            <h3 className="font-medium text-[#344854]">Create New Template</h3>
            <p className="text-sm text-gray-500 mt-1">Save your schedule patterns</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TemplatesDisplay; 